module.exports = __webpack_public_path__ + "assets/b823890e5a009e94fc3806f0addab755.svg";